/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum JOIN_TYPE_VALUES {
  CROSS = "cross",
  INNER = "inner",
  FULL = "full",
  LEFT = "left",
  RIGHT = "right",
  FULL_OUTER = "full-outer",
  LEFT_OUTER = "left-outer",
  RIGHT_OUTER = "right-outer",
}
